//
//
//
//
//
//

export default {
  name: 'app',

  created() {
    // 监听禁用后退
    window.addEventListener("popstate", (event) => {
        let path = this.$route.path
        if (path === "/" || path === "/login") {
          // console.log("/#" + path)
          // history.pushState(null, null, "/#" + path)
        }

      }
    );
  },
}



// WEBPACK FOOTER //
// ./src/App.vue